import React, { useState } from 'react';
import ReactDOM from 'react-dom';

const TOKEN = document.querySelector("[name='csrf-token']")?.content;

export default function RecordsHeader({
  columns, sortField, sortDir, onSort, allSelected, onSelectAll, onRefresh, showColumnOptions
}) {
  const [resizingCol, setResizingCol] = useState(null);
  const [resizeWidth, setResizeWidth] = useState('');
  const [resizePos, setResizePos] = useState({ top: 0, left: 0 });

  const handleOpenResize = (col, e) => {
    e.stopPropagation();
    const rect = e.currentTarget.getBoundingClientRect();
    setResizingCol(col);
    setResizeWidth(col.width || 220);
    setResizePos({ top: rect.bottom + 4, left: rect.left });
  };

  const handleSaveWidth = async () => {
    if (!resizeWidth || !resizingCol) return;
    try {
      await fetch(`/formatos/update_width/${resizingCol.id}`, {
        method: 'PATCH',
        headers: { 'X-CSRF-Token': TOKEN, 'Content-Type': 'application/json' },
        body: JSON.stringify({ column_width: parseInt(resizeWidth) })
      });
      setResizingCol(null);
      if (onRefresh) onRefresh();
    } catch (err) {
      console.error('Update width error:', err);
    }
  };

  const handleToggleWritingMode = async (col, e) => {
    e.stopPropagation();
    const newMode = col.writing_mode === 'vertical-lr' ? 'horizontal-tb' : 'vertical-lr';
    try {
      await fetch(`/formatos/update_writing_mode/${col.id}`, {
        method: 'PATCH',
        headers: { 'X-CSRF-Token': TOKEN, 'Content-Type': 'application/json' },
        body: JSON.stringify({ writingMode: newMode })
      });
      if (onRefresh) onRefresh();
    } catch (err) {
      console.error('Update writing mode error:', err);
    }
  };

  // Resize popover portal
  const resizePopover = resizingCol ? ReactDOM.createPortal(
    <>
      <div className="cm-menu-backdrop" onClick={() => setResizingCol(null)} />
      <div className="cm-resize-popover" style={{ top: resizePos.top, left: resizePos.left }}>
        <div className="cm-resize-popover__title">Cambiar tamaño</div>
        <input
          type="number"
          className="cm-resize-popover__input"
          value={resizeWidth}
          onChange={e => setResizeWidth(e.target.value)}
          onKeyDown={e => { if (e.key === 'Enter') handleSaveWidth(); if (e.key === 'Escape') setResizingCol(null); }}
          autoFocus
        />
        <div className="cm-resize-popover__actions">
          <button className="cm-btn cm-btn--sm cm-btn--primary" onClick={handleSaveWidth} disabled={!resizeWidth}>
            Actualizar
          </button>
          <button className="cm-btn cm-btn--sm" onClick={() => setResizingCol(null)}>
            Cancelar
          </button>
        </div>
      </div>
    </>,
    document.body
  ) : null;

  return (
    <>
      <tr className="cm-header-row">
        <th className="cm-dt-actions"></th>
        <th className="cm-dt-check">
          <input
            type="checkbox"
            className="cm-checkbox"
            checked={allSelected}
            onChange={onSelectAll}
          />
        </th>
        {columns.map(col => {
          const isActive = sortField === col.id.toString();
          const isVertical = col.writing_mode === 'vertical-lr';
          return (
            <th
              key={col.id}
              style={{ minWidth: Math.min(col.width, 400) }}
              onClick={() => onSort(col.id)}
            >
              <div className="cm-th-content">
                <span className={isVertical ? 'cm-th-vertical' : ''}>
                  {col.name}
                </span>
                {isActive ? (
                  <i className={`fas ${sortDir === 'asc' ? 'fa-caret-up' : 'fa-caret-down'} cm-sort-icon cm-sort-icon--active`} />
                ) : (
                  <span className="cm-sort-icon">⇅</span>
                )}
                {showColumnOptions && (
                  <span className="cm-th-col-actions">
                    <i
                      className="fas fa-text-width cm-th-col-action"
                      title="Cambiar tamaño"
                      onClick={(e) => handleOpenResize(col, e)}
                    />
                    <i
                      className={`fas fa-undo-alt cm-th-col-action${isVertical ? ' cm-th-col-action--active' : ''}`}
                      title={isVertical ? 'Rotar a horizontal' : 'Rotar a vertical'}
                      onClick={(e) => handleToggleWritingMode(col, e)}
                    />
                  </span>
                )}
              </div>
            </th>
          );
        })}
      </tr>
      {resizePopover}
    </>
  );
}
